import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-downArrow",
  "use": "icon-downArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-downArrow\"><path d=\"M63.9 324.3l72.8-72.8L512 626.9l375.3-375.4 72.8 72.8L512 772.5z\" fill=\"#333333\" p-id=\"1927\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol